// src/components/Dashboard.js
import React, { useState, useEffect } from 'react';
import api from '../services/api';
import './Dashboard.css';

function Dashboard() {
    const [stats, setStats] = useState({
        totalCalls: 0,
        incomingCalls: 0,
        outgoingCalls: 0,
        missedCalls: 0
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Filter states
    const [filters, setFilters] = useState({
        period: 'today',
        startDate: '',
        endDate: ''
    });

    useEffect(() => {
        fetchStats();
    }, []);

    const fetchStats = async () => {
        setLoading(true);
        setError(null);

        try {
            // Build query parameters
            const params = new URLSearchParams();
            params.append('period', filters.period);

            if (filters.period === 'custom') {
                if (filters.startDate) params.append('startDate', filters.startDate);
                if (filters.endDate) params.append('endDate', filters.endDate);
            }

            // Get filtered calls
            const filteredRes = await api.get(`/api/call-logs?${params.toString()}&limit=1000`);
            const filteredLogs = filteredRes.data.logs;

            // Get all calls (no period filter) for total count
            const allRes = await api.get('/api/call-logs?limit=1000');
            const allLogs = allRes.data.logs;

            // Calculate stats
            const incoming = filteredLogs.filter(log => log.dir === 'Incomming').length;
            const outgoing = filteredLogs.filter(log => log.dir === 'Outgoing').length;
            const missed = filteredLogs.filter(log => log.dir === 'Missed').length;

            setStats({
                totalCalls: allLogs.length,
                filteredCalls: filteredLogs.length,
                incomingCalls: incoming,
                outgoingCalls: outgoing,
                missedCalls: missed
            });
        } catch (err) {
            setError('Failed to fetch dashboard data');
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSearch = (e) => {
        e.preventDefault();
        fetchStats();
    };

    if (loading) return <div className="loading">Loading dashboard...</div>;
    if (error) return <div className="error">{error}</div>;

    return (
        <div className="dashboard">
            <h2>Dashboard</h2>

            <div className="filters">
                <form onSubmit={handleSearch}>
                    <div className="filter-row">
                        <div className="filter-group">
                            <label>Time Period</label>
                            <select
                                name="period"
                                value={filters.period}
                                onChange={handleFilterChange}
                            >
                                <option value="today">Today</option>
                                <option value="week">Last Week</option>
                                <option value="month">Last Month</option>
                                <option value="custom">Custom Range</option>
                            </select>
                        </div>

                        {filters.period === 'custom' && (
                            <>
                                <div className="filter-group">
                                    <label>Start Date</label>
                                    <input
                                        type="date"
                                        name="startDate"
                                        value={filters.startDate}
                                        onChange={handleFilterChange}
                                    />
                                </div>
                                <div className="filter-group">
                                    <label>End Date</label>
                                    <input
                                        type="date"
                                        name="endDate"
                                        value={filters.endDate}
                                        onChange={handleFilterChange}
                                    />
                                </div>
                            </>
                        )}

                        <button type="submit" className="filter-btn">Apply Filters</button>
                    </div>
                </form>
            </div>

            <div className="stats-container">
                <div className="stat-card total">
                    <h3>Total Calls</h3>
                    <div className="stat-value">{stats.totalCalls}</div>
                </div>
                <div className="stat-card filtered">
                    <h3>{filters.period === 'today' ? "Today's Calls" :
                        filters.period === 'week' ? "Last Week's Calls" :
                            filters.period === 'month' ? "Last Month's Calls" :
                                "Filtered Calls"}</h3>
                    <div className="stat-value">{stats.filteredCalls || 0}</div>
                </div>
                <div className="stat-card incoming">
                    <h3>Incoming Calls</h3>
                    <div className="stat-value">{stats.incomingCalls}</div>
                </div>
                <div className="stat-card outgoing">
                    <h3>Outgoing Calls</h3>
                    <div className="stat-value">{stats.outgoingCalls}</div>
                </div>
                <div className="stat-card missed">
                    <h3>Missed Calls</h3>
                    <div className="stat-value">{stats.missedCalls}</div>
                </div>
            </div>
        </div>
    );
}

export default Dashboard;